import { testimonials } from '@/mocks/testimonials';

const avatarImages: Record<string, string> = {
  'avatar-zhang': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20adult%20male%20learner%2C%20warm%20smile%2C%20neutral%20background%2C%20soft%20lighting%2C%20professional%20style&width=100&height=100&seq=avatar-zhang&orientation=squarish',
  'avatar-li': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20adult%20female%20learner%2C%20warm%20smile%2C%20neutral%20background%2C%20soft%20lighting%2C%20professional%20style&width=100&height=100&seq=avatar-li&orientation=squarish',
  'avatar-wang': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20adult%20female%20learner%20with%20glasses%2C%20warm%20smile%2C%20neutral%20background%2C%20soft%20lighting%2C%20professional%20style&width=100&height=100&seq=avatar-wang&orientation=squarish',
  'avatar-chen': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20male%20learner%2C%20friendly%20expression%2C%20neutral%20background%2C%20soft%20lighting%2C%20modern%20style&width=100&height=100&seq=avatar-chen&orientation=squarish',
  'avatar-liu': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20adult%20male%20learner%20in%20business%20attire%2C%20confident%20smile%2C%20neutral%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-liu&orientation=squarish',
  'avatar-zhao': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20adult%20female%20learner%20in%20business%20attire%2C%20professional%20smile%2C%20neutral%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-zhao&orientation=squarish',
};

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            学员真实评价
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            来自50,000+学员的真实反馈，98%的学员满意度是我们最好的证明
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-xl p-6 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                  <img
                    src={avatarImages[t.avatarSeq] || avatarImages['avatar-zhang']}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>

              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-4">
                &ldquo;{t.content}&rdquo;
              </p>

              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>{t.course}</span>
                <span>{t.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}